/**
 * NovelTemplate のメイン領域スクロールを先頭に戻す。
 * PC では `.main`、SP では `.main` 内の `.flex-1` が scroll コンテナ。
 */
export function scrollNovelMainToTop(): void {
  const main = document.querySelector<HTMLElement>(".main");
  if (main) {
    main.scrollTop = 0;
    main.scrollLeft = 0;
  }

  const nested = main?.querySelector<HTMLElement>(".flex-1");
  if (nested) {
    nested.scrollTop = 0;
    nested.scrollLeft = 0;
  }

  window.scrollTo(0, 0);
}
